import { Controller } from '@hotwired/stimulus';
import Swiper, {Pagination, Navigation, EffectFade, FreeMode, Autoplay, Keyboard} from 'swiper';

export default class extends Controller {
    static values = {
        name: String,
        bulletNames: Array,
        config: Object,
    }
    connect() {
        Swiper.use([Navigation, Pagination, EffectFade, FreeMode, Autoplay, Keyboard]);

        const name = this.nameValue;
        const config = this.configValue;
        const bulletNames = this.bulletNamesValue;

        if (bulletNames.length) {
            config.pagination = {
                el: `.${name} .slider-pagination`,
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (bulletNames[index]) + '</span>';
                },
            }
        }

        this.swiper = new Swiper(`.${name}`, config);
    }

    slideTo(index) {
        console.log("slideTo method triggered for index:", index);
        this.swiper.slideTo(index);
    }
}
